import * as React from 'react';
import { FC } from 'react';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';

const LimitWarning: FC<{ reason: string; locales: Locales }> = ({ reason, locales }) => (
  <div className="limit-warning rs-text-align_center">
    <p className="reason">{reason}</p>
    {translation(locales, 'limits_link_text_1')}{' '}
    <a href="/player/limits">{translation(locales, 'limits_link_text_2')}</a>
  </div>
);

export default LimitWarning;
